import { type FC, type InputHTMLAttributes, useId } from "react";

export type CheckboxProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "size"
> & {
  label?: string;
  error?: string;
  helperText?: string;
  helperTextClassName?: string;
  labelClassName?: string;
  containerClassName?: string;
  formControlClassName?: string;
  wrapperClassName?: string;
};

const Checkbox: FC<CheckboxProps> = ({
  label,
  error,
  helperText,
  helperTextClassName = "",
  labelClassName = "",
  containerClassName = "",
  wrapperClassName = "",
  formControlClassName = "",
  ...props
}) => {
  const inputId = useId();

  return (
    <div className={wrapperClassName}>
      <div className={`form-control ${formControlClassName}`}>
        <label
          className={`label cursor-pointer justify-start gap-3 ${containerClassName}`}
          htmlFor={inputId}
        >
          <input
            className="checkbox-primary checkbox"
            id={inputId}
            type="checkbox"
            {...props}
          />
          <span className={`label-text ${labelClassName}`}>{label}</span>
        </label>
      </div>
      {error || helperText ? (
        <span
          className={`text-xs ${
            error ? "text-orange" : "text-gray-400"
          } ${helperTextClassName}`}
        >
          {error ?? helperText}
        </span>
      ) : null}
    </div>
  );
};

export default Checkbox;
